import { render, staticRenderFns } from "./detail_page.vue?vue&type=template&id=95cd7d94&scoped=true"
import script from "./detail_page.vue?vue&type=script&lang=ts"
export * from "./detail_page.vue?vue&type=script&lang=ts"
import style0 from "./detail_page.vue?vue&type=style&index=0&id=95cd7d94&prod&scoped=true&lang=less"
import style1 from "./detail_page.vue?vue&type=style&index=1&id=95cd7d94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd7d94",
  null
  
)

export default component.exports